<template>
  <div class="app-container paper-subject">
    <basic-container class = "paper-subject-container">
      <div class="paper-subject-container-head">
        <h2>{{title}}</h2>
        <hr>
      </div>
      <div class="paper-subject-container-content">
        <div class="paper-subject-container-single" v-if="singleSubjectList.length > 0">
          <subject-component :subjectDetailList="singleSubjectList" :type="subjectTypeMap.single.value" :isShow="true"/>
        </div>
        <div class="paper-subject-container-single" v-if="mutipleSubjectList.length > 0">
          <subject-component :subjectDetailList="mutipleSubjectList" :type="subjectTypeMap.mutiple.value" :isShow="true"/>
        </div>
        <div class="paper-subject-container-single" v-if="judgementSubjectList.length > 0">
          <subject-component :subjectDetailList="judgementSubjectList" :type="subjectTypeMap.judgement.value" :isShow="true"/>
        </div>
        <div class="paper-subject-container-single" v-if="fillSubjectList.length > 0">
          <subject-component :subjectDetailList="fillSubjectList" :type="subjectTypeMap.fill.value" :isShow="true"/>
        </div>
        <div class="paper-subject-container-single" v-if="questionSubjectList.length > 0">
          <subject-component :subjectDetailList="questionSubjectList" :type="subjectTypeMap.question.value" :isShow="true"/>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { getSubjectDetailList } from '@/api/app/subject'
import { getPaperDetail } from '@/api/app/paper'
import { mapGetters } from 'vuex'
import { subjectTypeMap, subjectTypeList } from '@/const/crud/app/subject-lib'
import subjectComponent from './components/subject-component.vue'

export default {
  name: 'choice-subject',
  components: {
    subjectComponent,
  },
  data() {
    return {
      subjectTypeMap,
      subjectTypeList,
      id: '',
      title: '',
      singleSubjectList: [],
      mutipleSubjectList: [],
      judgementSubjectList: [],
      fillSubjectList: [],
      questionSubjectList: [],
    }
  },
  created() {
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  mounted() {
    this.id = this.$route.params.id;
    if(this.id) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      getPaperDetail(this.id).then(res => {
        this.title = res.data.data.title
        this.initData(res.data.data.paper.subjectRelations)
      }).catch(error => {
        this.$message({
          message: '获取试卷信息失败',
          type: 'error'
        })
      })
    },
    initData(data) {
      data.forEach(item => {
        let param = item.subject
        param.score = item.score
        param.sort = item.subjectSort
        param.relationId = item.id
        this.fillSubejctList(item.subject.type, param)
      })
    },
    fillSubejctList(type, item) {
      switch (type) {
        case this.subjectTypeMap.single.value:
          this.singleSubjectList.push(item)
          break;
        case this.subjectTypeMap.mutiple.value:
          this.mutipleSubjectList.push(item)
          break;
        case this.subjectTypeMap.judgement.value:
          this.judgementSubjectList.push(item)
          break;
        case this.subjectTypeMap.fill.value:
          this.fillSubjectList.push(item)
          break;
        case this.subjectTypeMap.question.value:
          this.questionSubjectList.push(item)
          break;
        default:
          break;
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.paper-subject {
  &-container {
    padding-top: 0px;
    &-head {
      padding-bottom: 10px;
      text-align: center;
    }
    &-content {
      min-height: 300px;
    }
    &-single {
      margin-left: 40px;
      margin-right: 20px;
      text-align: left;
      &-content {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
